import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardFooter from '../components/DashboardFooter';

const FuneralCryptoATMLearnMorePage = () => {
  const navigate = useNavigate();

  const hotScamsLinks = [
    { label: 'Phishing \\ Smishing \\ Spoofing', path: '/dashboard/phishing-learn-more' },
    { label: 'Pig Butchering', path: '/dashboard/cryptocurrency-learn-more' },
    { label: 'Catfishing', path: '/dashboard/catfishing-learn-more' },
    { label: 'Tech Support', path: '/dashboard/tech-support-learn-more' },
    { label: 'Work From Home', path: '/dashboard/work-from-home-learn-more' },
    { label: 'Government Impersonation', path: '/dashboard/law-enforcement-impersonation-learn-more' },
  ];

  const psaVideos = [
    'Abused in Salt Lake City',
    'No good deed ( Charity )',
    '$700,000– Price of Love',
    'Can it happen to me',
    'Scam Red Flags',
    'Scam Red Flags',
    'Grandparent',
    'Grandparent',
    'Tech Support',
    'Phantom Hacker',
  ];

  return (
    <div className="h-full overflow-y-auto bg-white flex flex-col items-center">
      <div className="w-full max-w-[1920px]">

        {/* 1. Hero Image */}
        <div className="px-12 pt-6">
          <div className="relative w-full overflow-hidden rounded-lg" style={{ height: '220px' }}>
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: 'url(/mockup_images/marketing-remodel/Dashboard/LearnMore/LearnMore-CryptocurrencyPig.jpeg)',
              }}
            />
          </div>
        </div>

        {/* 2. Title + Stats */}
        <div className="px-12 pt-8 pb-2">
          <h1 className="text-3xl font-bold text-black mb-1">Funeral Crypto ATM</h1>
          <p className="text-base text-gray-700 mb-0">10,956 victims \ $246 Million stolen</p>
          <p className="text-sm text-gray-500">Source → FBI \\ IC3 2024 IC3 Annual Report</p>
        </div>

        {/* 3. What you need to know */}
        <div className="px-12 py-6">
          <h2 className="text-xl font-bold text-black mb-3">What you need to know</h2>
          <p className="text-black leading-relaxed">
            Cryptocurrency ATM scams have become one of the fastest-growing fraud categories tracked by the FBI. In 2024, the IC3 received 10,956 complaints related to crypto kiosk fraud — a 99% increase from the previous year — resulting in $246.7 million in stolen funds. These machines, which look like ordinary ATMs, can be found in grocery stores, gas stations, laundromats, and convenience stores across more than 30,000 locations nationwide.
            Scammers exploit moments of grief and vulnerability by targeting people who have recently lost a loved one. Posing as funeral home representatives, insurance agents, or estate administrators, they contact victims claiming there are outstanding fees, tax obligations, or insurance processing costs that must be paid immediately — and that payment must be made through a cryptocurrency ATM.
            Adults over 60 account for more than 85% of reported fraud losses involving crypto kiosks, making seniors the primary target of this scheme.
          </p>
        </div>

        {/* 4. Two side-by-side cards */}
        <div className="px-12 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="border-l-4 border-blue-400 bg-blue-50 p-6 rounded-r-lg">
              <h3 className="text-lg font-bold text-black mb-4">01. Scammer Warning Signs</h3>
              <ul className="space-y-2 text-black text-sm">
                <li>Contact from someone claiming to represent a funeral home or estate</li>
                <li>Demands for immediate payment during a period of grief</li>
                <li>Instructions to use a cryptocurrency ATM for payment</li>
              </ul>
            </div>
            <div className="border-l-4 border-blue-400 bg-blue-50 p-6 rounded-r-lg">
              <h3 className="text-lg font-bold text-black mb-4">02. Scammer Method</h3>
              <ul className="space-y-2 text-black text-sm">
                <li>Impersonation of funeral directors or insurance agents</li>
                <li>QR codes directing deposits at crypto kiosks</li>
                <li>Threats of disrupted funeral arrangements or legal action</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 5. Prevention Tips */}
        <div className="w-full" style={{ backgroundColor: '#4A6D8C' }}>
          <div className="px-12 py-8">
            <h3 className="text-lg font-bold text-white mb-4">03. Prevention Tips</h3>
            <ul className="space-y-2 text-white text-sm leading-relaxed">
              <li>- Legitimate funeral homes, insurance companies, and estate administrators will never demand payment through a cryptocurrency ATM.</li>
              <li>- Be suspicious of any unsolicited call or message demanding urgent payment — especially during a period of grief.</li>
              <li>- Never deposit money into a crypto ATM at the direction of someone you've only spoken with by phone, text, or email.</li>
              <li>- Verify all claims independently by calling the funeral home or insurance company directly using a number you find yourself.</li>
              <li>- If someone sends you a QR code and asks you to deposit money at a crypto kiosk, it is a scam.</li>
            </ul>
          </div>
        </div>

        {/* 6. FBI PSA Videos */}
        <div className="px-12 py-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
            <div>
              <h3 className="text-xl font-bold text-black mb-4">05. FBI PSA Videos</h3>
              <div className="grid grid-cols-2 gap-x-8 gap-y-2 mb-6">
                {psaVideos.map((title, idx) => (
                  <p key={idx} className="text-sm text-black">{title}</p>
                ))}
              </div>
              <button
                onClick={() => navigate('/dashboard/av-library/fbi-ic3')}
                className="w-full md:w-auto px-12 py-3 border-2 border-gray-300 rounded-lg text-black text-sm font-medium hover:bg-gray-50 transition-colors"
              >
                Watch videos
              </button>
            </div>
            <div className="flex justify-end">
              <img
                src="/mockup_images/marketing-remodel/Dashboard/LearnMore/LearnMore-PhishingSmishingSpoofing-2.jpeg"
                alt="FBI PSA"
                className="rounded-lg object-cover w-full"
                style={{ maxHeight: '320px' }}
              />
            </div>
          </div>
        </div>

        {/* 7. Personal Safety */}
        <div
          className="w-full relative bg-cover bg-center"
          style={{
            backgroundImage: 'url(/mockup_images/marketing-remodel/Dashboard/LearnMore/LearnMore-PhishingSmishingSpoofing-3.jpeg)',
            minHeight: '280px',
          }}
        >
          <div className="px-12 py-10 flex items-center" style={{ minHeight: '280px' }}>
            <div className="max-w-md">
              <h3 className="text-xl font-bold text-white mb-3">06 Personal Safety</h3>
              <p className="text-white text-sm leading-relaxed">
                Call the police immediately if you feel there is a danger to yourself or a loved one.
              </p>
            </div>
          </div>
        </div>

        {/* 8. Hot Scams Footer */}
        <div className="px-12 py-10 border-t border-gray-200">
          <h3 className="text-xl font-bold text-black mb-4">Hot Scams</h3>
          <div className="grid grid-cols-3 gap-x-8 gap-y-2">
            {hotScamsLinks.map((scam, idx) => (
              <button
                key={idx}
                onClick={() => navigate(scam.path)}
                className="text-left text-sm text-black hover:text-blue-600 cursor-pointer py-1"
              >
                {scam.label}
              </button>
            ))}
          </div>
        </div>

      </div>
      <DashboardFooter />
    </div>
  );
};

export default FuneralCryptoATMLearnMorePage;
